module.exports = __webpack_public_path__ + "img/inventory.11d34fe4.svg";